export enum ReadingActions {
  PlayPause = 'PlayPause',
  MoveForward = 'MoveForward',
  MoveBackward = 'MoveBackward',
  Stop = 'Stop'
}

export enum TabNames {
  About = 'ABOUT',
  Navigation = 'NAVIGATION',
  Speech = 'SPEECH',
  Tutorial = 'TUTORIAL',
  UiSettings = 'UISETTINGS',
  DrawingStyles = 'DRAWINGSTYLES',
  TextNotesStyles = 'TEXTNOTESSTYLES',
  SpellChecker = 'SPELL_CHECKER_SETTINGS',
  WordPrediction = 'WORD_PREDICTION_SETTINGS',
  ReaderLayout = 'READER_LAYOUT',
  CloudSettings = 'CLOUD_SETTINGS',
}

export enum ModalWindowsTypes {
  'SETTINGS_WINDOW' = 'SETTINGS_WINDOW',
  'LOOKUP_WINDOW' = 'LOOKUP_WINDOW',
  'TRANSALTE_WINDOW' = 'TRANSALTE_WINDOW',
  'SEARCH_WINDOW' = 'SEARCH_WINDOW',
  'DOCUMENT_OPENED_WINDOW' = 'DOCUMENT_OPENED_WINDOW',
  'KICK_SESSION_DIALOG' = 'KICK_SESSION_DIALOG',
  'LOST_FILES_DIALOG' = 'LOST_FILES_DIALOG',
  'CLOUD_STORAGE_DIALOG' = 'CLOUD_STORAGE_DIALOG',
  'DODP_STORAGE_DIALOG' = 'DODP_STORAGE_DIALOG',
  'STI_DIALOG' = 'STI_DIALOG',
  'EPUB_ANNOTATIONS_DIALOG' = 'EPUB_ANNOTATIONS_DIALOG',
  'COMMON_ERROR_DIALOG' = 'COMMON_ERROR_DIALOG',
  'EXTRACTION_OPTIONS' = 'EXTRACTION_OPTIONS',
  'EXTRA_COPY_DIALOG' = 'EXTRA_COPY_DIALOG',
  'PDF_PAGE_SELECT_DIALOG' = 'PDF_PAGE_SELECT_DIALOG',
  'SPINNER_DIALOG' = 'SPINNER_DIALOG',
  'CORRECTION_LIST' = 'CORRECTION_LIST',
  'GET_FOLDER_NAME' = 'GET_FOLDER_NAME',
  'FILENAME_DIALOG' = 'FILENAME_DIALOG',
  'DELETE_FILE_DIALOG' = 'DELETE_FILE_DIALOG',
  'FILE_MOVE_DIALOG' = 'FILE_MOVE_DIALOG',
  'FILE_MANAGER_DIALOG' = 'FILE_MANAGER_DIALOG',
  'AUTOSAVE_RESTORE_DIALOG' = 'AUTOSAVE_RESTORE_DIALOG',
  'AUDIOMAKER_DIALOG' = 'AUDIOMAKER_DIALOG',
  'FILE_MOVING_WARNING_DIALOG' = 'FILE_MOVING_WARNING_DIALOG',
  'YES_NO_DIALOG' = 'YES_NO_DIALOG',
  'EXAM_MODE_PROPERTIES_WINDOW' = 'EXAM_MODE_PROPERTIES_WINDOW',
  'ADD_TIME_RESTRICTION_DIALOG' = 'ADD_TIME_RESTRICTION_DIALOG',
  'COMPLETED_EXAM_PREVIEW_DIALOG' = 'COMPLETED_EXAM_PREVIEW_DIALOG',
  'ENTER_ACCESS_CODE_DIALOG' = 'ENTER_ACCESS_CODE_DIALOG',
  'SUBMITTED_EXAM_INFORMATION_DIALOG' = 'SUBMITTED_EXAM_INFORMATION_DIALOG',
  'PENDING_EXAMS_WINDOW' = 'PENDING_EXAMS_WINDOW',
  'SUBMITTED_EXAMS_WINDOW' = 'SUBMITTED_EXAMS_WINDOW',
}

export enum TextNotesFontTypeStyle {
  NORMAL = 'NORMAL',
  UNDERLINED = 'UNDERLINED',
  STROKE = 'STROKE',
}

